import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventList: [],
  eventTickets: [],
  eventBadgeDetails:null,
  loading:false,
  error:null
};

const eventListSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    resetEvents:(state)=>{
      state.eventList = [];
      state.eventTickets = [];
      state.eventBadgeDetails=null;
      state.loading=false;
      state.error=null;
    },
    OnLoadingEvent:(state,action)=>{
        state.loading=true;
        state.eventList=[];

    },
    OnSuccessEvent: (state, action) => {
      state.eventList = action.payload;
      state.loading=false;
    },
    OnSuccessTicket: (state, action) => {
      state.eventTickets = action.payload;
      state.loading=false;
    },
    OnFailureEvent: (state, action) => {
      state.error = action.payload;
    },
    setEventBadgeDetail:(state,action)=>{
     state.eventBadgeDetails=action.payload;
    }
  },
});

export const {resetEvents, OnFailureEvent, OnSuccessEvent, OnLoadingEvent,OnSuccessTicket,setEventBadgeDetail} =
eventListSlice.actions;

export const getSelectedEventList = (state) => state.events;
export const getSelectedTicketList = (state) => state.events.eventTickets;
export const getSelectedEventBadge = (state) => state.events?.eventBadgeDetails;
export default eventListSlice.reducer;
